// extracted by mini-css-extract-plugin
export default {"content":"Zla-z","title":"_la-z","subTitle":"ama-z","banner":"bma-z","productCardOverride":"cma-z"};